<!-- Add penalty form -->
<div class="add-edit-penality-modal" *ngIf="iPenaltyForm" [ngClass]="{ 'edit-penality-modal':iEditPenaltyForm }">
  <snl-modal [type]="'medium'" [open]="iPenaltyForm" [settings]="setting">
    <div slot="heading" *ngIf="iAddPenaltyForm">Add Penalty</div>
    <div slot="heading" *ngIf="iEditPenaltyForm">Edit Penalty</div>
    <div slot="headingDescription">
      <span class="text d-flex">
        <span class="d-flex container-c-bx col-gap-8">
          Ship : 
          <span class="ShipsPillsMain fw-700 CommonPillsMain color__primary d-flex"> 
            <span class="truncate-txt single-line ship-name"> {{shipDetail.vslName}}</span>
            <span class="ShipNumberPills CommonPills fw-400 labels d-flex align-items-center">{{shipDetail.vslNumber}} </span>
          </span>
        </span>
      </span>
    </div>
    <div slot="modalContent">
      <form [formGroup]="penaltyForm">
        <div class="d-flex disabled penaltyDiv"  [ngClass]="{disabled:iEditPenaltyForm}">
          <snl-input [type]="'text'" label="Penalty" formControlName="penalty" placeholder="" [value]="penaltyForm.value.penalty" [isError]="((penaltyForm.controls['penalty'].hasError('required') || penaltyForm.controls['penalty'].hasError('pattern')) && viewModel.submit)"></snl-input>
        </div>
        <div class="d-flex effectiveDiv" [ngClass]="{disabled:iEditPenaltyForm}">
          <div class="effectiveDate half-containers">
            <snl-input  class="disabled datepicker" [ngClass]="{disabled:iEditPenaltyForm}" snlDatePicker [min]="viewModel.minDate" [startMonthDate] = "viewModel.effectiveFormDate" (selectedDate) = "selectedDate($event,'effectiveFormDate')"  placeholder="" label="Effective Date" formControlName="effectiveFormDate" [value]="penaltyForm.value.effectiveFormDate" [isError]="(penaltyForm.controls['effectiveFormDate'].hasError('required') && viewModel.submit)" [isTrailingIconDisplayed]="true" trailingIcon="fa-calendar far"></snl-input>
          </div>
          <div class="half-containers timeDiv" [ngClass]="{disabled:iEditPenaltyForm}">
            <snl-time-picker  placeholder="" timeLabel="Effective Time (GMT)" [setTime] = "setTime(penaltyForm.value.effectiveFormTime)" (apply) = "selectedTime($event,'effectiveFormTime')"></snl-time-picker>
          </div>
        </div>
        <div class="reason" [ngClass]="{disabled:iEditPenaltyForm}">
          <snl-input label="Reason" formControlName="reason" placeholder="Due to Operational Reasons"  [value]="penaltyForm.value.reason" [isError]="(penaltyForm.controls['reason'].hasError('required') && viewModel.submit)"></snl-input>
        </div>
        <div *ngIf="iEditPenaltyForm">
          <div class="margin-10" >
            <snl-checkbox
              [isDisable]="false"
              [checked]="viewModel.isClosePenaltyChecked"
              [intermediate]="false"
              [id]="'checkbox-btn-sample'"
              [name]="'closePenalty'"
              [value]="'closePenalty'"
              (onClick)="onClickClosePenalty($event)"
            >
            Close Penalty
            </snl-checkbox>
          </div>
          <div class="d-flex effectiveDiv" *ngIf="viewModel.isClosePenaltyChecked">
            <div class="effectiveDate half-containers">
              <snl-input class="datepicker df-c" snlDatePicker [min]="viewModel.minDate" [startMonthDate] = "viewModel.closeEffectiveDate" (selectedDate) = "selectedDate($event,'closeEffectiveDate')" placeholder="" label="Effective Date" [value]="penaltyForm.value.closeEffectiveDate" formControlName="closeEffectiveDate" [isError]="(penaltyForm.controls['closeEffectiveDate'].hasError('required') && viewModel.submit)" [isTrailingIconDisplayed]="true" trailingIcon="fa-calendar far"></snl-input>
            </div>
            <div class="half-containers timezoneDiv">
              <snl-time-picker  placeholder="" timeLabel="Effective Time (GMT)" [setTime] = "setTime(penaltyForm.value.closeEffectiveTime)" (apply) = "selectedTime($event,'closeEffectiveTime')"></snl-time-picker>
            </div>
          </div>
        </div>
        
      </form>
    </div>
    <div slot="modalFooter">
      <snl-button size="small" (buttonClick)="submitPenalty()" [disabled]="submitPenaltyDisabled()">Save</snl-button>
      <snl-button size="small" type="secondary" (buttonClick)="closePopup()">Cancel</snl-button>
    </div>
  </snl-modal>
</div>
